<div class="container" *ngIf="!errValue && !invalidLink">
    <div class="col-md-12 lease_table ">
        <div>
            <div class="migration_detials">Student Hall Ticket No. Verification
            </div>
            <!-- <div class="col-md-12"> -->
                <div>
                    <form [formGroup]="student">
                        <div class="mt-3">
                            <div  class="col-md-12 mb-3 application">
                                <label class="col-md-5">Application No. </label>
                                <input type="text" class="form-control student_name col-md-3" formControlName="AdmNo" (keypress)="allowOnlyNumbers($event)"
                                    placeholder="Enter Student Application No.">
                            </div>
                            <div  class="col-md-12 mb-3 application">
                                <label class="col-md-5">Registered Mobile No.</label>
                                <input type="text" class="form-control col-md-3 student_name" maxlength="4" (keypress)="allowOnlyNumbers($event)"
                                    formControlName="Mobilenumber" placeholder="Last 4 digits">
                            </div>
                            <div *ngIf="studentdetials">
                                <div  class="col-md-12 mb-3 application"
                                    *ngIf="studentdetials">
                                    <label class="col-md-5">Student Name </label>
                                    <p class="student_nm">{{studentdetials.StudentName}}</p>
                                </div>
                                <div  class="col-md-12 mb-3 application">
                                    <label class="col-md-5">SSC 10th Hall Ticket No.</label>
                                    <input type="text" class="form-control student_name col-md-3" formControlName="hallticketnumber"  (keypress)="allowAlphanumericOnly($event)"
                                        placeholder="Enter 10th Hall Ticket No." minlength="10" maxlength="10">
                                        <!-- <button class="col-md-1 btn btn-primary verify"  (click)="gethtticket()">Verify</button> -->
                                </div>
                               <div *ngIf="studentHallTicketName" class="display_col">
                                <span  class="as_per font_14" > {{studentHallTicketName}}</span>
                                <span  class="as_per">As per SSC </span>
                               </div>
                            </div>
                        </div>

                    </form>
                    <div class="col-lg-12 text-center mt-3" *ngIf="saveButton">
                        <button type="button" class="cctv_notebtn" (click)="savestudent()">Save</button>
                    </div>
                </div>
            <!-- </div> -->
        </div>
    </div>
</div>
<div *ngIf="errValue">
    <h2 style="color: red; text-align: center; padding-top: 20px;">SSC Hall Ticket Details Submitted Successfully</h2>
</div>
<div *ngIf="invalidLink">
    <h2 style="color: red; text-align: center; padding-top: 20px;">Invalid Link</h2>
</div>
<div *ngIf="hallTIcketerror">
    <h2 style="color: red; text-align: center; padding-top: 20px;">Please Enter Valid Hall Ticket Number</h2>
</div>
<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>